import React from 'react';
import InlineActions from '../app/header/InlineActions';
import { useShowInlineActions } from '../app/header/useInlineActions';
import PageShell from '../app/PageShell';
import CartContent from './CartContent';

const CartPage: React.FC = () => {
  const showInlineActions = useShowInlineActions();

  return (
    <PageShell className="cart">
      {showInlineActions && <InlineActions />}
      <div className="container-fluid">
        <div className="content-wrapper">
          <div className="page-inner">
            <div className="cart-inner">
              <div className="container">
                <div className="row center">
                  <div className="col-lg-12">
                    <h1 className="cart-title heading">Your Cart</h1>
                    <CartContent />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default CartPage;
